import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import { EmployerPostSelect, EmployerOption } from '@carcareers/components';
import { useForm } from '@carcareers/contexts';

export const EmployerStepForm: FC = () => {
  const { data, setData } = useForm();

  const handleEmployerChange = (employer: EmployerOption | null) => {
    setData('employer', employer?.employer);
    setData('rooftop', null);
    setData('job', null);
  };

  // Convert raw employer object back to EmployerOption for the autocomplete
  const employerValue = useMemo((): EmployerOption | null => {
    if (!data?.employer) return null;
    
    const employer = data.employer;
    return {
      label: `${employer.user?.firstName || ''} ${employer.user?.lastName || ''}`.trim() ||
             employer.user?.email ||
             `Employer #${employer.id}`,
      value: employer.id,
      employer,
    };
  }, [data?.employer]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <EmployerPostSelect value={employerValue} onChange={handleEmployerChange} />
      {data?.employer && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="h4">Details</Typography>
          <Typography variant="body1">
            {data?.employer?.user.firstName ?? ''} {data?.employer?.user.lastName ?? ''}
          </Typography>
          <Typography variant="body1">
            {data?.employer?.user.email ?? ''}
          </Typography>
          <Typography variant="body1">
            {data?.employer?.user.phone ?? ''}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default EmployerStepForm;
